module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Almootamayezoon","short_name":"Almootamayezoon","start_url":"/","background_color":"#572C09","theme_color":"#572C09","display":"minimal-ui","icon":"src/images/products/icon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
